import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Modal, Stack, Typography } from "@mui/material";
import { FormEventHandler, ReactNode } from "react";

// Shared centered modal card used by the salary create/edit and pay popups.
// Matches the house modal framing (537px card, #D0D5DD border, boxShadow 24).
const SalaryModalCard = ({
  open,
  onClose,
  title,
  onSubmit,
  children,
}: {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  onSubmit: FormEventHandler<HTMLFormElement>;
  children: ReactNode;
}) => (
  <Modal open={open} onClose={onClose}>
    <Stack
      component="form"
      onSubmit={onSubmit}
      spacing={3}
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: { xs: "90%", sm: "537px" },
        maxHeight: "90vh",
        overflowY: "auto",
        bgcolor: "#FFF",
        border: "1px solid #D0D5DD",
        borderRadius: 1,
        boxShadow: 24,
        p: 3,
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" p={0}>
        <Typography color="#101828" fontSize="20px" lineHeight="24px">
          {title}
        </Typography>
        <IconButton onClick={onClose} sx={{ p: 0 }}>
          <CloseIcon />
        </IconButton>
      </Box>
      {children}
    </Stack>
  </Modal>
);

export default SalaryModalCard;
